import { getExchangeName as getExchangeNameFromApi } from "@/app/apiServices/market/service"

const getExchangeName = (exchange: string, lang: string) =>
	getExchangeNameFromApi(exchange, lang)

export default getExchangeName
